// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2guwg","content":"Consent_content__ft0oH","footer":"Consent_footer__35Uec"};